import { compose } from 'recompose';
import { connect } from 'react-redux';

import { fetchSalesByBarberAndShop } from '../metrics/actions';
import {
  getSalesByBarberAndShopWithProductivity,
} from '../metrics/selectors';

const withDefaultSalesByBarberDataProvider = compose(
  connect(
    state => ({
      data: getSalesByBarberAndShopWithProductivity(state),
    }),
    {
      fetcher: fetchSalesByBarberAndShop,
    }
  ),
);

export default withDefaultSalesByBarberDataProvider;
